import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _10_CO2_ABSORPTION:Partial<EcosystemServiceModel> ={
  id:'co2-absorption',
  pos:10,
  image: "/images/ecoservices/co2_absorption.jpg",
  code: ["2.2.6.1"],
  unit:'CO₂ absorption',
  assetType:'species',
  serviceType: 'regulating',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "tons",
      element: "CO₂ absorved",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ],
  restrictions:{
    onlyAllowed:['land_forestry']
  }

}
